// ============================================================
// 后台路由实例
// 用户详情走 GET /admin/user/info，菜单走 GET /admin/menus
// ============================================================
import { createDynamicRouter } from "@shared/router";
import Layout from "@shared/layout/index.vue";
import { fetchCurrentUserInfo, fetchCurrentUserMenus } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { staticRoutes } from "./routes";

const router = createDynamicRouter({
    staticRoutes,
    fetchUserMenus: async () => {
        const data = await fetchCurrentUserInfo();
        const currentUser = useCurrentUserStore();
        currentUser.hydrateFromInfo(data);
        const items = await fetchCurrentUserMenus();
        currentUser.setMenus(items);
        return items;
    },
    layout: Layout,
    whiteList: ["/login", "/404", "/403"],
    baseTitle: import.meta.env.VITE_APP_TITLE || "1P后台",
    loginPage: () => import("@app/views/login.vue"),
    requireAuth: true,
});

export default router;
